import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { translate, Trans } from 'react-i18next';

const ClearAll = styled.div`
  display: inline-block;
  text-transform: capitalize;
  padding: ${props => props.theme.paddings.small}px ${props => props.theme.paddings.medium}px;
  margin-bottom: ${props => props.theme.paddings.large}px;
  font-size: ${props => props.theme.fonts.sizes.small}px;
  font-weight: ${props => props.theme.fonts.weights.semiBold};
  color: ${props => props.theme.colors.secondary};
  letter-spacing: 0.4px;
  cursor: pointer;
`;
const ClearAllTracks = ({ onClick }) => (
  <ClearAll onClick={onClick}>
    <Trans i18nKey="SelectedTags.clearAll" />
  </ClearAll>
);

ClearAllTracks.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default translate('ecommerceCoreUI')(ClearAllTracks);
